import { render, staticRenderFns } from "./PurchasesDeliveryViewValidateDeliveryForm.vue?vue&type=template&id=04e2d8bc&scoped=true"
import script from "./PurchasesDeliveryViewValidateDeliveryForm.vue?vue&type=script&lang=js"
export * from "./PurchasesDeliveryViewValidateDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./PurchasesDeliveryViewValidateDeliveryForm.vue?vue&type=style&index=0&id=04e2d8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2d8bc",
  null
  
)

export default component.exports